import {
  TagType,
  Props as InViewTrackingProps,
} from '../../components/InViewTracking/InViewTracking';
import dynamic from 'next/dynamic';
import { BuilderComponentProps } from '../../builder';
import { SectionNameType } from './events';

type Props = {
  as?: TagType;
  className?: string;
  sectionName: SectionNameType;
};

const InViewTracking = dynamic<InViewTrackingProps>(() =>
  import('../../components/InViewTracking/InViewTracking').then(
    (mod) => mod.InViewTracking,
  ),
);

export const withTracking =
  <T extends BuilderComponentProps>(
    Component: React.ElementType,
    config: Props,
  ) =>
  (props: T) => {
    return (
      <InViewTracking
        as={config?.as}
        className={config.className}
        sectionName={config.sectionName}
        layerName={props.builderBlock?.layerName}
      >
        <Component {...props} />
      </InViewTracking>
    );
  };
